<template>
  <div class="depositChannelsPage">
    <div class="pageHeadBg"></div>
    <div class="channelInfoBox">
      <div class="title">{{ $t('lang.account.depositChannelTitle') }}</div>
      <div class="num">₹{{ depositInfo.amount }}</div>
      <div class="channelCard">
        <div class="cardHead">
          <img src="../../assets/images/account/walletSelectIcon.png" alt="" class="headIcon">
          <div class="headText">{{ $t('lang.account.SelectOptionPay') }}</div>
        </div>
        <div class="cardBody">
          <div class="channelItem" v-for="(item, index) in payList" :key="index" @click="selectPayChannel(item.key)">
            <div class="leftBox">
              <img v-if="item.icon && item.key !=='paytm'" :src="item.icon" alt="" class="icon">
              <img v-if="item.icon && item.key ==='paytm'" :src="item.icon" alt="" class="icon2">
              <div class="label">{{ item.label }}</div>
            </div>
            <div class="checkBox">
              <img v-if="item.key === depositInfo.payChannel" src="../../assets/images/account/checked.png" alt=""
                   class="check">
              <div v-else class="nocheck"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submitBox">
      <div class="submit" @click="goToApp()">{{ $t('lang.account.pay') }}</div>
      <div class="tip">{{ $t('lang.account.depositChannelTip') }}</div>
    </div>
  </div>
</template>

<script>
import phonepe from '../../assets/images/account/channelIcon-phonepe.png'
import payTm from '../../assets/images/account/channelIcon-payTm.png'
// import googlePay from '../../assets/images/account/channelIcon-googlePay.png'
// import bhim from '../../assets/images/account/channelIcon-bhim.png'
export default {
  name: 'index',
  data () {
    return {
      depositInfo: {
        payChannel: 'phonepe',
        amount: null
      },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      orderInfo: {},
      payList: [
        {
          key: 'phonepe',
          icon: phonepe,
          label: 'PhonePe'
        },
        {
          key: 'paytm',
          icon: payTm,
          label: 'Paytm'
        }
        // {
        //   key: 'gpay',
        //   icon: googlePay,
        //   label: 'Google Pay'
        // },
        // {
        //   key: 'bhim',
        //   icon: bhim,
        //   label: 'BHIM'
        // }
        // {
        //   key: 'otherUpi',
        //   icon: '',
        //   label: 'Other Upi '
        // }
      ]
    }
  },
  created () {
    console.log(this.$route.query)
    if (this.$route.query && this.$route.query.depositInfo) {
      this.depositInfo = {...this.depositInfo, ...JSON.parse(this.$route.query.depositInfo)}
      this.parseUPIString(this.depositInfo.Url)
    }
  },
  methods: {
    selectPayChannel (payChannel) {
      this.depositInfo.payChannel = payChannel
    },
    parseUPIString (upiString) {
      // 增强的格式校验
      if (!upiString || typeof upiString !== 'string') {
        throw new Error('输入必须是字符串')
      }

      if (upiString.indexOf('upi://pay?') !== 0) { // 替代 startsWith 的兼容写法
        throw new Error('无效的 UPI 协议格式')
      }

      // 手动解析参数
      var params = {}
      var queryPart = upiString.split('?')[1] || ''
      var pairs = queryPart.split('&')

      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=')
        if (pair.length < 2) continue
        var key = pair[0]
        var value = decodeURIComponent(pair.slice(1).join('=')) // 处理包含等号的值
        params[key] = value
      }
      // 提取目标字段
      var result = {
        pa: params.pa,
        pn: params.pn,
        cu: params.cu,
        am: params.am,
        tr: params.tr,
        mc: params.mc,
        mam: params.mam,
        mode: params.mode,
        ver: params.ver,
        orgId: params.orgId,
        url: window.location.host + '/deposit'
      }

      // 空值检查
      var requiredFields = ['pa', 'pn', 'cu', 'am', 'tr']
      requiredFields.forEach(function (field) {
        if (typeof result[field] === 'undefined' || result[field].trim() === '') {
          throw new Error('缺少必要参数: ' + field)
        }
      })
      this.orderInfo = result
    },
    buildParams (params) {
      const query = Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&')
      return query ? `?${query}` : ''
    },
    goToApp () {
      const upiParameter = this.buildParams({
        pa: this.orderInfo.pa,
        pn: this.orderInfo.pn,
        am: this.orderInfo.am,
        tr: this.orderInfo.tr
      })

      const upiParameterBHIM = this.buildParams({
        pn: this.orderInfo.pn,
        pa: this.orderInfo.pa,
        cu: 'INR',
        am: this.orderInfo.am,
        tr: this.orderInfo.tr,
        url: this.orderInfo.url,
        mode: this.orderInfo.mode
      })

      const upiParameterPaytmmp = this.buildParams({
        pn: this.orderInfo.pn,
        pa: this.orderInfo.pa,
        cu: 'INR',
        am: this.orderInfo.am,
        tr: this.orderInfo.tr,
        mode: this.orderInfo.mode,
        mc: this.orderInfo.mc,
        ver: this.orderInfo.ver,
        orgId: this.orderInfo.orgId,
        mam: this.orderInfo.mam
      })
      if (this.depositInfo.payChannel === 'paytm') {
        window.open('paytmmp://pay' + upiParameterPaytmmp)
      } else if (this.depositInfo.payChannel === 'phonepe') {
        window.open('phonepe://pay' + upiParameter)
      } else if (this.depositInfo.payChannel === 'gpay') {
        window.open('gpay://upi/pay' + upiParameter)
      } else if (this.depositInfo.payChannel === 'bhim') {
        window.open('bhim://pay' + upiParameterBHIM)
      } else {
        window.open('upi://pay' + upiParameter)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.depositChannelsPage {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #E3E3E3;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 29vw;

  .pageHeadBg {
    width: 100%;
    height: 112.222vw;
    background: linear-gradient(to bottom,
    #355FDE 10%,
    #4574FF 40%,
    #E3E3E3 60%);
    position: absolute;
    top: 0;
    z-index: 0;
  }

  .channelInfoBox {
    height: 112.777vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
    gap: 4vw;
    margin-top: 9.722vw;

    .title {
      font-size: 4.72vw;
      font-weight: 700;
      color: #FFFFFF;
    }

    .num {
      font-weight: 700;
      color: #FFFFFF;
      font-size: 12.5vw;
      position: relative;
      top: 10vw;
    }

    .channelCard {
      //height:  81.111vw;
      height: 39.111vw;
      //height:  26.111vw;
      width: 91.352vw;
      background-color: #fff;
      border-radius: 1.944vw;
      display: flex;
      flex-direction: column;
      position: relative;
      top: 17vw;

      .cardHead {
        height: 11.944vw;
        width: 100%;
        border-radius: 1.944vw 1.944vw 0 0;
        background: linear-gradient(90deg, #DDECFF 0%, #FFFFFF 100%);
        box-shadow: 0px 0px 4.4px rgba(0, 0, 0, 0.11);
        display: flex;
        align-items: center;
        padding-left: 3.166vw;

        .headIcon {
          width: 5.444vw;
          height: 3.888vw;
        }

        .headText {
          margin-left: 1.111vw;
          font-family: 'Suez One';
          font-weight: 700;
          text-transform: capitalize;
          color: #061A4C;
          font-size: 3.888vw;
        }
      }

      .cardBody {
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;

        .channelItem {
          height: 13.333vw;
          width: 83.333vw;
          border-bottom: 1px solid #F2F2F2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-shrink: 0;

          .leftBox {
            display: flex;
            align-items: center;
            gap: 3vw;

            .icon {
              height: 5.555vw;
              width: 5.555vw;
            }

            .icon2 {
              width: 5.872vw;
              height: 3.302vw;
            }

            .label {
              color: #000;
              font-size: 3.888vw;
              font-weight: 700;
            }
          }

          .checkBox {
            .check {
              height: 5vw;
              width: 5vw;
            }

            .nocheck {
              box-sizing: border-box;
              border: 1px solid #B1B1B1;
              height: 5vw;
              width: 5vw;
              border-radius: 10vw;
            }
          }
        }

        .channelItem:nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
  }

  .submitBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4vw;

    .submit {
      background-color: #3762E2;
      width: 91.172vw;
      height: 12.222vw;
      border-radius: 0.833vw;
      color: #fff;
      font-size: 4.722vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Inter;
    }

    .tip {
      width: 91.172vw;
      font-size: 3.333vw;
      color: #787878;
      font-weight: 500;
      font-family: Inter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/depositChannelsPage/index.vue